'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SaveDraftButton = require('./components/SaveDraftButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SaveDraftButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/save-draft-button/index.js
// module id = 1054
// module chunks = 0